var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutnavbar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 34.839,
    viewBox: "0 0 26 34.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log_out_nav_bar",
    "data-name": "Log out nav bar",
    transform: "translate(-3348.5 523.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98401",
    "data-name": "Trazado 98401",
    d: "M11.5,0a11.731,11.731,0,0,1,5.758,1.543A11.375,11.375,0,0,1,23,11.5,11.5,11.5,0,1,1,11.5,0Z",
    transform: "translate(3350 -513)",
    fill: "none",
    stroke: "#e72431",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_98400",
    "data-name": "Trazado 98400",
    transform: "translate(228)",
    fill: "red",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3133.5 -498 C 3131.570068359375 -498 3130 -499.5700988769531 3130 -501.5 L 3130 -517.8392333984375 C 3130 -519.7691650390625 3131.570068359375 -521.3392333984375 3133.5 -521.3392333984375 C 3135.429931640625 -521.3392333984375 3137 -519.7691650390625 3137 -517.8392333984375 L 3137 -501.5 C 3137 -499.5700988769531 3135.429931640625 -498 3133.5 -498 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3133.5 -500 C 3134.328369140625 -500 3135 -500.6715698242188 3135 -501.5 L 3135 -517.8392333984375 C 3135 -518.6676635742188 3134.328369140625 -519.3392333984375 3133.5 -519.3392333984375 C 3132.671630859375 -519.3392333984375 3132 -518.6676635742188 3132 -517.8392333984375 L 3132 -501.5 C 3132 -500.6715698242188 3132.671630859375 -500 3133.5 -500 M 3133.5 -496 C 3130.46728515625 -496 3128 -498.46728515625 3128 -501.5 L 3128 -517.8392333984375 C 3128 -520.8719482421875 3130.46728515625 -523.3392333984375 3133.5 -523.3392333984375 C 3136.53271484375 -523.3392333984375 3139 -520.8719482421875 3139 -517.8392333984375 L 3139 -501.5 C 3139 -498.46728515625 3136.53271484375 -496 3133.5 -496 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutnavbar);
export default __webpack_public_path__ + "static/media/Log out nav bar.eeb1701a2aca555ad79177e1e9c37dd4.svg";
export { ForwardRef as ReactComponent };